export const FUND_PAGE_PATH = '/fund'
